var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66669 0.833496C6.12692 0.833496 6.50002 1.20659 6.50002 1.66683V2.50016H11.5V1.66683C11.5 1.20659 11.8731 0.833496 12.3334 0.833496C12.7936 0.833496 13.1667 1.20659 13.1667 1.66683V2.50016H14C15.841 2.50016 17.3334 3.99255 17.3334 5.8335V15.0002C17.3334 16.8411 15.841 18.3335 14 18.3335H4.00002C2.15907 18.3335 0.666687 16.8411 0.666687 15.0002V5.8335C0.666687 3.99255 2.15907 2.50016 4.00002 2.50016H4.83335V1.66683C4.83335 1.20659 5.20645 0.833496 5.66669 0.833496ZM11.5 4.16683C11.5 4.62707 11.8731 5.00016 12.3334 5.00016C12.7936 5.00016 13.1667 4.62707 13.1667 4.16683H14C14.9205 4.16683 15.6667 4.91302 15.6667 5.8335V6.25016H2.33335V5.8335C2.33335 4.91302 3.07955 4.16683 4.00002 4.16683H4.83335C4.83335 4.62707 5.20645 5.00016 5.66669 5.00016C6.12692 5.00016 6.50002 4.62707 6.50002 4.16683H11.5ZM15.6667 7.91683H2.33335V15.0002C2.33335 15.9206 3.07955 16.6668 4.00002 16.6668H14C14.9205 16.6668 15.6667 15.9206 15.6667 15.0002V7.91683Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.714893e87bcc775c9b5db8f291ee10f2.svg";
export { ForwardRef as ReactComponent };